(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[121],{

/***/ "./src/components/Wiki/WikiAccordion/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var _styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/styles/markdown.module.css");
/* harmony import */ var _styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2__);





const WikiAccordion = (param)=>{
    let { title , withNoDarkBg , children , defaultOpen , ...rest } = param;
    const [first, setfirst] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultOpen ? (_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionOpen) : (_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionDisplay));
    const ChangeStyle = ()=>{
        if (first === (_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionDisplay)) {
            setfirst((_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionUnDisplay));
        } else if (first === (_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionUnDisplay)) {
            setfirst((_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionDisplay));
        } else if (first === (_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionOpen)) {
            setfirst((_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionClose));
        } else {
            setfirst((_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionOpen));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        w: "100%",
        borderWidth: 1,
        bgColor: "wikiCardBg",
        _dark: {
            bgColor: withNoDarkBg ? "gray.800" : "gray.700"
        },
        p: 3,
        borderRadius: 8,
        borderColor: "rankingListBorder",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                cursor: "pointer",
                onClick: ChangeStyle,
                justify: "start",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .IconButton */ .hU, {
                        color: "linkColor",
                        variant: "link",
                        minW: 3,
                        "aria-label": "toggle".concat(title),
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_5__/* .RiArrowDownSLine */ .ZXJ, {}),
                        transform: first === (_styles_markdown_module_css__WEBPACK_IMPORTED_MODULE_2___default().accordionUnDisplay) ? "" : "rotate(180deg)",
                        transition: "all 0.3s ease"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                        style: {
                            userSelect: "none",
                            WebkitUserSelect: "none"
                        },
                        fontSize: "14px",
                        color: "linkColor",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .chakra.div */ .m$.div, {
                className: first,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                    p: 2,
                    mt: 1,
                    ...rest,
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WikiAccordion);


/***/ }),

/***/ "./src/components/Wiki/WikiPage/InsightComponents/RelatedMedia.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RelatedMedia; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/bigpicture/src/BigPicture.js
var BigPicture = __webpack_require__("./node_modules/bigpicture/src/BigPicture.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Elements/MediaPreview/MediaPreview.tsx


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore



const MediaPreview = (param)=>{
    let { type ="IPFS_IMG" , src , children , className , style , onClick , animationStart , animationEnd , onClose , onError , onChangeImage , noLoader , ...rest } = param;
    const elRef = react.useRef(null);
    const isPlayable = type === "IPFS_VID" || type === "YOUTUBE" || type === "VIMEO";
    const zoomHandle = ()=>{
        if (!elRef.current) return;
        const options = {
            el: elRef.current
        };
        switch(type){
            case "IPFS_IMG":
                options.imgSrc = src;
                break;
            case "IPFS_VID":
                options.vidSrc = src;
                break;
            case "YOUTUBE":
                // eslint-disable-next-line prefer-destructuring
                options.ytSrc = src.split("=")[1];
                break;
            case "VIMEO":
                options.vimeoSrc = src.replace(/(https?:\/\/)?(www\.)?vimeo\.com\//, "");
                break;
            default:
                options.imgSrc = src;
                break;
        }
        if (typeof onError === "function") {
            options.onError = onError;
        }
        if (typeof animationStart === "function") {
            options.animationStart = animationStart;
        }
        if (typeof animationEnd === "function") {
            options.animationEnd = animationEnd;
        }
        if (typeof onClose === "function") {
            options.onClose = onClose;
        }
        if (typeof onChangeImage === "function") {
            options.onChangeImage = onChangeImage;
        }
        if (noLoader) {
            options.noLoader = true;
        }
        const bp = (0,BigPicture/* default */.Z)(options);
        // 16:9 ratio with height of window.innerHeight - 200px
        const height = window.innerHeight - 200;
        const width = height * 16 / 9;
        bp.opts.dimensions = [
            width,
            height
        ];
        bp.updateDimensions();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        cursor: "pointer",
        className: "bigpicture link picture ".concat(className || ""),
        onClick: ()=>{
            if (onClick) onClick();
            zoomHandle();
        },
        ref: elRef,
        position: "relative",
        style: {
            display: "inline-block",
            ...style
        },
        ...rest,
        children: [
            isPlayable && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                as: ri_index_esm/* RiPlayLine */.hpr,
                fontSize: "30px",
                position: "absolute",
                zIndex: 999,
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                bgColor: "whiteAlpha.400",
                borderRadius: "50%",
                p: 1,
                w: 8,
                h: 8
            }),
            children
        ]
    });
};
/* harmony default export */ var MediaPreview_MediaPreview = (MediaPreview);

// EXTERNAL MODULE: ./src/utils/DataTransform/mediaUtils.tsx
var mediaUtils = __webpack_require__("./src/utils/DataTransform/mediaUtils.tsx");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
// EXTERNAL MODULE: ./src/components/Wiki/WikiAccordion/index.tsx
var WikiAccordion = __webpack_require__("./src/components/Wiki/WikiAccordion/index.tsx");
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/InsightComponents/RelatedMedia.tsx








const RELATED_MEDIA_IMAGE_BOX_SIZE = 150;
const RelatedMediaGrid = (param)=>{
    let { media  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)("wiki");
    if (!media || media.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "100%",
        spacing: 4,
        borderRadius: 2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiAccordion/* default */.Z, {
            title: t("Media"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                columns: {
                    base: 3,
                    xl: 3,
                    sm: 4,
                    md: 6,
                    "2xl": 4
                },
                spacing: 3,
                children: media.map((m, i)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                        ratio: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaPreview_MediaPreview, {
                            type: m.source,
                            src: (0,mediaUtils/* constructMediaUrl */.w)(m),
                            bgColor: "dimColor",
                            borderRadius: 4,
                            boxSize: "100%",
                            overflow: "hidden",
                            "data-caption": m === null || m === void 0 ? void 0 : m.caption,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                boxSize: "100%",
                                src: m.source !== "YOUTUBE" ? (0,mediaUtils/* constructMediaUrl */.w)(m) : "https://i3.ytimg.com/vi/".concat(m.name, "/maxresdefault.jpg"),
                                alt: "related media",
                                imgBoxSize: RELATED_MEDIA_IMAGE_BOX_SIZE,
                                hideOnError: true,
                                objectFit: "cover",
                                bgColor: "fadedText2"
                            })
                        }, i)
                    }, i);
                })
            })
        })
    });
};
/* harmony default export */ var RelatedMedia = (RelatedMediaGrid);


/***/ }),

/***/ "./src/components/Wiki/WikiPage/WikiMainContent.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ MarkdownRender; },
  "Z": function() { return /* binding */ WikiPage_WikiMainContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@everipedia/iq-utils/build/module/index.js + 2 modules
var build_module = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/spinner/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 112 modules
var react_markdown = __webpack_require__("./node_modules/react-markdown/lib/react-markdown.js");
// EXTERNAL MODULE: ./node_modules/remark-gfm/index.js + 31 modules
var remark_gfm = __webpack_require__("./node_modules/remark-gfm/index.js");
// EXTERNAL MODULE: ./src/store/store.ts + 9 modules
var store = __webpack_require__("./src/store/store.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customHeadingRender.tsx


const addToTOC = (param)=>{
    let { children , ...props } = param;
    var ref;
    const level = Number((ref = props.node.tagName.match(/h(\d)/)) === null || ref === void 0 ? void 0 : ref.slice(1));
    if (level && children && typeof children[0] === "string") {
        const id = "".concat(children[0].toLowerCase().replace(/[^a-z0-9]+/g, "-"), "-").concat(store/* store.getState */.h.getState().toc.length);
        store/* store.dispatch */.h.dispatch({
            type: "toc/addToc",
            payload: {
                level,
                id,
                title: children[0]
            }
        });
        return /*#__PURE__*/ react.createElement(props.node.tagName, {
            id
        }, children);
    }
    return /*#__PURE__*/ react.createElement(props.node.tagName, props, children);
};

// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiFields.ts
var getWikiFields = __webpack_require__("./src/utils/WikiUtils/getWikiFields.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popover/dist/index.esm.js + 1 modules
var popover_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/popover/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tag/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/LinkRenderers/CiteMarksRender.tsx
/* eslint-disable react-hooks/rules-of-hooks */ 



const CiteMarksRender = (param)=>{
    let { text , href , referencesString  } = param;
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const id = href === null || href === void 0 ? void 0 : href.split("#cite-id-")[1];
    const [count, setCount] = (0,react.useState)(0);
    const [isActive, setIsActive] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const onHashChanged = ()=>{
            setIsActive(window.location.hash === "#cite-mark-".concat(id, "-").concat(count));
        };
        window.addEventListener("hashchange", onHashChanged);
        return ()=>{
            window.removeEventListener("hashchange", onHashChanged);
        };
    }, [
        count,
        id
    ]);
    (0,react.useEffect)(()=>{
        store/* store.dispatch */.h.dispatch({
            type: "citeMarks/incCiteCount",
            payload: id
        });
        const storedCount = store/* store.getState */.h.getState().citeMarks[id || ""];
        setCount(storedCount);
    }, [
        id
    ]);
    const references = referencesString ? JSON.parse(referencesString) : [];
    const ref = references.find((r)=>r.id === id);
    const citeOpenTimeout = (0,react.useRef)(null);
    const openCitePopup = (0,react.useCallback)(()=>{
        citeOpenTimeout.current = setTimeout(()=>setIsOpen(true), 100);
    }, []);
    const closeCitePopup = (0,react.useCallback)(()=>{
        if (citeOpenTimeout.current) {
            clearTimeout(citeOpenTimeout.current);
        }
        setIsOpen(false);
    }, []);
    const citeLink = /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
        onMouseLeave: closeCitePopup,
        onMouseEnter: openCitePopup,
        onFocus: ()=>{},
        onBlur: ()=>{},
        href: href,
        borderRadius: "100px",
        color: "brandLinkColor",
        _focus: {
            outline: "none",
            textDecoration: "underline"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
            as: "sup",
            id: "cite-mark-".concat(id, "-").concat(count),
            scrollMarginTop: "50vh",
            bgColor: isActive ? "#e160a12a" : "transparent",
            boxShadow: isActive ? "0 0 0 3px #e160a12a" : "none",
            borderRadius: 2,
            zIndex: -1,
            children: text
        })
    });
    if (!isOpen) return citeLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
        isOpen: true,
        returnFocusOnClose: false,
        autoFocus: false,
        "aria-label": "Wiki preview",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                children: citeLink
            }),
            ref && /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverContent */.yk, {
                boxShadow: "rgb(4 17 29 / 25%) 0px 0px 8px 0px",
                _focus: {
                    outline: "none"
                },
                mx: 4,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverArrow */.QH, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverBody */.b, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                                flexWrap: "wrap",
                                gap: 1,
                                p: 1,
                                mb: 1,
                                borderBottomWidth: ref.description.trim().length ? "1px" : 0,
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                        colorScheme: "blue",
                                        size: "sm",
                                        fontWeight: "medium",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Link */.rU, {
                                            color: "#304262 !important",
                                            _dark: {
                                                color: "#9dcbf0 !important"
                                            },
                                            fontSize: "sm",
                                            p: "0 !important",
                                            href: ref.url,
                                            children: new URL(ref.url).hostname
                                        })
                                    }),
                                    ref.timestamp && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                        m: "2px !important",
                                        opacity: 0.6,
                                        fontSize: "sm",
                                        children: new Date(ref.timestamp).toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                m: "2px !important",
                                fontSize: "sm",
                                children: ref.description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LinkRenderers_CiteMarksRender = (CiteMarksRender);

// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__("./src/config/index.ts");
// EXTERNAL MODULE: ./src/utils/textUtils.ts
var textUtils = __webpack_require__("./src/utils/textUtils.ts");
// EXTERNAL MODULE: ./src/components/WikiImage.tsx
var WikiImage = __webpack_require__("./src/components/WikiImage.tsx");
// EXTERNAL MODULE: ./src/services/wikis/index.ts
var wikis = __webpack_require__("./src/services/wikis/index.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiSummary.ts
var getWikiSummary = __webpack_require__("./src/utils/WikiUtils/getWikiSummary.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/LinkRenderers/WikiLinkRender.tsx








const WikiLinkPreviewSkeleton = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverHeader */.Yt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                    justify: "center",
                    opacity: 0.8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            boxSize: 5
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 20
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverBody */.b, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                    align: "start",
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            boxSize: 20,
                            flexShrink: 0
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* VStack */.gC, {
                            w: "full",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: 5,
                                    w: "full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: 5,
                                    w: "full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    h: 5,
                                    w: "full"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverFooter */.DT, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                    spacing: 2,
                    align: "center",
                    flexWrap: "wrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            h: 5,
                            w: 10
                        })
                    ]
                })
            })
        ]
    });
const WikiLinkPreview = (param)=>{
    let { wikiId  } = param;
    var ref, ref1;
    const { data: wiki , isLoading  } = (0,wikis/* useGetWikiPreviewQuery */.w3)(wikiId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* PopoverContent */.yk, {
        boxShadow: "rgb(4 17 29 / 25%) 0px 0px 8px 0px",
        _focus: {
            outline: "none"
        },
        mx: 4,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverArrow */.QH, {}),
            !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverHeader */.Yt, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                            justify: "center",
                            opacity: 0.8,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    as: ri_index_esm/* RiLightbulbLine */.dc7
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    fontSize: "15px",
                                    children: wiki === null || wiki === void 0 ? void 0 : wiki.title
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverBody */.b, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                            align: "start",
                            spacing: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiImage/* WikiImage */.R, {
                                    mt: 1,
                                    borderRadius: 2,
                                    overflow: "hidden",
                                    flexShrink: 0,
                                    w: "100px",
                                    h: "100px",
                                    imageURL: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki === null || wiki === void 0 ? void 0 : wiki.images),
                                    alt: (wiki === null || wiki === void 0 ? void 0 : wiki.title) || "wiki"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    fontSize: "14px",
                                    children: wiki && (0,getWikiSummary/* getWikiSummary */.L)(wiki)
                                })
                            ]
                        })
                    }),
                    (wiki === null || wiki === void 0 ? void 0 : (ref = wiki.tags) === null || ref === void 0 ? void 0 : ref.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverFooter */.DT, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* HStack */.Ug, {
                            gap: "1",
                            align: "center",
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(tag_dist_index_esm/* Tag */.Vp, {
                                    variant: "outline",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* TagLeftIcon */.AD, {
                                            mr: 1,
                                            boxSize: "12px",
                                            as: ri_index_esm/* RiPriceTagLine */.ckV
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* TagLabel */.Sn, {
                                            ml: 0,
                                            fontSize: "12px",
                                            children: "TAGS"
                                        })
                                    ]
                                }),
                                wiki === null || wiki === void 0 ? void 0 : (ref1 = wiki.tags) === null || ref1 === void 0 ? void 0 : ref1.map((tag, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                                        bgColor: "hsl(".concat(Math.floor(i * 0.5 * 360), ", 40%, 80%)"),
                                        color: "black",
                                        children: tag.id
                                    }, i))
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiLinkPreviewSkeleton, {})
        ]
    });
};
const WikiLinkRender = (param)=>{
    let { href , text , slug  } = param;
    const [isOpen, setIsOpen] = react.useState(false);
    const linkRef = react.useRef(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover_dist_index_esm/* Popover */.J2, {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        returnFocusOnClose: false,
        "aria-label": "Wiki preview",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover_dist_index_esm/* PopoverTrigger */.xo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    ref: linkRef,
                    onMouseOver: ()=>setIsOpen(true),
                    onMouseOut: ()=>setIsOpen(false),
                    onFocus: ()=>{},
                    onBlur: ()=>{},
                    href: href,
                    color: "brandLinkColor",
                    children: text
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiLinkPreview, {
                wikiId: slug
            })
        ]
    });
};
/* harmony default export */ var LinkRenderers_WikiLinkRender = (WikiLinkRender);

// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/index.es.jsx
var index_es = __webpack_require__("./node_modules/react-lite-youtube-embed/dist/index.es.jsx");
// EXTERNAL MODULE: ./node_modules/react-lite-youtube-embed/dist/LiteYouTubeEmbed.css
var LiteYouTubeEmbed = __webpack_require__("./node_modules/react-lite-youtube-embed/dist/LiteYouTubeEmbed.css");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/LinkRenderers/WidgetLinkRender.tsx




const WidgetLinkRender = (param)=>{
    let { text , href  } = param;
    const [iframeLoading, setIframeLoading] = (0,react.useState)(true);
    const [isInView, setIsInView] = (0,react.useState)(false);
    const widgetRef = react.useRef(null);
    (0,react.useEffect)(()=>{
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            if (entry.isIntersecting) setIsInView(true);
        }, {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        });
        observer.observe(widgetRef.current);
        return ()=>observer.disconnect();
    }, []);
    const iframeLoadHandler = ()=>{
        setIframeLoading(false);
    };
    const renderWidget = (src, title, type)=>{
        if (type === "youtube") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                ref: widgetRef,
                className: "embed-widget-iframe embed-widget-iframe__loaded",
                children: isInView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                    id: src,
                    title: ""
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            ref: widgetRef,
            className: iframeLoading ? "embed-widget-iframe" : "embed-widget-iframe embed-widget-iframe__loaded",
            children: isInView ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                className: type === "dune" ? "embed-widget-iframe-dune-bg" : "",
                onLoad: iframeLoadHandler,
                loading: "lazy",
                title: title,
                src: src
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        });
    };
    switch(text){
        case "YOUTUBE@VID":
            return renderWidget(href, "youtube video", "youtube");
        case "DUNE@EMBED":
            return renderWidget("https://dune.com/embeds/".concat(href), "Dune Embed", "dune");
        default:
            return null;
    }
};
/* harmony default export */ var LinkRenderers_WidgetLinkRender = (WidgetLinkRender);

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customLinkRender.tsx








const customLinkRenderer = (param)=>{
    let { children , referencesString , ...props } = param;
    var ref;
    const linkHref = props.href;
    const linkText = typeof children[0] === "string" ? children[0] : "";
    const wikiSlug = (ref = linkHref === null || linkHref === void 0 ? void 0 : linkHref.match(new RegExp("".concat(config/* default.publicDomain */.Z.publicDomain, "/wiki/(.*)")))) === null || ref === void 0 ? void 0 : ref[1];
    const isWikiLink = linkText.length > 0 && wikiSlug;
    if (isWikiLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRenderers_WikiLinkRender, {
            href: linkHref,
            text: linkText,
            slug: wikiSlug
        });
    }
    const isCiteIdPresent = linkHref === null || linkHref === void 0 ? void 0 : linkHref.match(/#cite-id-(.*)/);
    if (isCiteIdPresent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRenderers_CiteMarksRender, {
            referencesString: referencesString,
            href: linkHref,
            text: linkText
        });
    }
    const isWidgetLink = linkText && linkHref && build_module/* whiteListedLinkNames.includes */.Kp.includes(linkText) && !(0,textUtils/* isValidUrl */.jv)(linkHref);
    if (isWidgetLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkRenderers_WidgetLinkRender, {
            text: linkText,
            href: linkHref
        });
    }
    return /*#__PURE__*/ react.createElement(props.node.tagName, props, children);
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("./node_modules/next/image.js");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customImageRender.tsx




const customImageRender = (param)=>{
    let { ...props } = param;
    const { src  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        quality: 95,
        loader: Image/* cfLoader */.f,
        src: src || "",
        alt: "wiki",
        width: 900,
        height: 400,
        style: {
            width: "auto",
            height: "auto",
            position: "static"
        }
    });
};

;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/CustomRenderers/customTableRender.tsx


const customTableRenderer = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "table-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
            ...props,
            children: children
        })
    });
};

// EXTERNAL MODULE: ./src/styles/markdown.module.css
var markdown_module = __webpack_require__("./src/styles/markdown.module.css");
var markdown_module_default = /*#__PURE__*/__webpack_require__.n(markdown_module);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/index.esm.js + 1 modules
var toast_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/toast/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 30 modules
var modal_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/modal/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/textarea/dist/index.esm.js
var textarea_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/textarea/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js + 3 modules
var hooks_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/react/node_modules/@chakra-ui/hooks/dist/index.esm.js");
// EXTERNAL MODULE: ./src/hooks/useAddress.ts
var useAddress = __webpack_require__("./src/hooks/useAddress.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiFlaggingSystem.tsx






const FlaggingSystemModal = (param)=>{
    let { id , isOpen , onClose  } = param;
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const [flagContent, setFlagContent] = (0,react.useState)("");
    const [postFlagWiki] = (0,wikis/* usePostFlagWikiMutation */.I0)();
    const { address  } = (0,useAddress/* useAddress */.S)();
    const postFlagHandler = async (e)=>{
        e.preventDefault();
        if (!address) {
            toast({
                title: "Please, login to report this wiki's content.",
                status: "error",
                duration: 5000,
                isClosable: true
            });
            return;
        }
        const postFlagWikiData = await postFlagWiki({
            report: flagContent,
            wikiId: id,
            userId: address
        });
        if (!Object.keys(postFlagWikiData).includes("error")) {
            toast({
                title: "Your report has been successfully submitted!",
                status: "success",
                duration: 5000,
                isClosable: true
            });
            onClose();
        } else {
            toast({
                title: "There was an error submitting your report.",
                status: "error",
                duration: 5000,
                isClosable: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        size: {
            base: "md",
            md: "2xl"
        },
        motionPreset: "slideInBottom",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalContent */.hz, {
                mx: {
                    base: "15px",
                    md: "0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    onSubmit: postFlagHandler,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalHeader */.xB, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    children: "Report"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    fontWeight: 500,
                                    mt: "3",
                                    pb: "3",
                                    fontSize: {
                                        base: "sm",
                                        md: "md"
                                    },
                                    borderBottomWidth: "1px",
                                    borderBottomColor: "wikiFlagTextBorderColor",
                                    color: "wikiFlagTextColor",
                                    children: "Please, in a few words, write about what you would like to be reported in the text box below."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(textarea_dist_index_esm/* Textarea */.g, {
                                fontWeight: 400,
                                fontSize: "sm",
                                minH: "200px",
                                color: "wikiFlagTextAreaColor",
                                borderColor: "wikiFlagTextAreaBorderColor",
                                placeholder: "Write your text here....",
                                name: "report-content",
                                onChange: (e)=>setFlagContent(e.currentTarget.value)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalFooter */.mz, {
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                                type: "submit",
                                background: "brandLinkColor",
                                fontSize: "sm",
                                fontWeight: "400",
                                w: {
                                    base: "full",
                                    md: "initial"
                                },
                                disabled: flagContent.trim().length === 0,
                                children: "Confirm"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const WikiFlaggingSystem = (param)=>{
    let { id  } = param;
    const { isOpen , onOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const toast = (0,toast_dist_index_esm/* useToast */.pm)();
    const { address  } = (0,useAddress/* useAddress */.S)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isOpen && address && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlaggingSystemModal, {
                onClose: onClose,
                isOpen: isOpen,
                id: id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                mt: {
                    base: "5",
                    lg: "10"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                    direction: {
                        base: "column",
                        md: "row"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                            as: "span",
                            children: "See something wrong? "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                            as: "span",
                            ml: {
                                base: "0",
                                md: "1"
                            },
                            color: "brandLinkColor",
                            cursor: "pointer",
                            display: "flex",
                            onClick: ()=>{
                                if (address) {
                                    onOpen();
                                } else {
                                    toast({
                                        title: "Please, login to report this wiki's content.",
                                        status: "error",
                                        duration: 5000,
                                        isClosable: true
                                    });
                                }
                            },
                            _dark: {
                                color: "brand.800"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Text */.xv, {
                                    as: "span",
                                    children: "Report to us."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                                    as: "span",
                                    ml: "5px",
                                    alignItems: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                        fontSize: {
                                            base: "md",
                                            sm: "lg"
                                        },
                                        as: ri_index_esm/* RiFlagFill */.msm
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__("./node_modules/react-redux/es/index.js");
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__("./src/utils/googleAnalytics.ts");
// EXTERNAL MODULE: ./src/data/LanguageData.ts
var LanguageData = __webpack_require__("./src/data/LanguageData.ts");
;// CONCATENATED MODULE: ./src/components/Wiki/WikiPage/WikiMainContent.tsx

















const MarkdownRender = /*#__PURE__*/ react.memo((param)=>{
    let { wiki  } = param;
    store/* store.dispatch */.h.dispatch({
        type: "citeMarks/reset"
    });
    store/* store.dispatch */.h.dispatch({
        type: "toc/reset"
    });
    const referencesString = (0,react.useMemo)(()=>{
        var ref;
        return (ref = (0,getWikiFields/* getWikiMetadataById */.lU)(wiki, build_module/* CommonMetaIds.REFERENCES */.wA.REFERENCES)) === null || ref === void 0 ? void 0 : ref.value;
    }, [
        wiki
    ]);
    if (!wiki.content) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
        remarkPlugins: [
            remark_gfm/* default */.Z
        ],
        components: {
            h1: addToTOC,
            h2: addToTOC,
            h3: addToTOC,
            h4: addToTOC,
            h5: addToTOC,
            h6: addToTOC,
            a: (props)=>customLinkRenderer({
                    ...props,
                    referencesString
                }),
            img: customImageRender,
            table: customTableRenderer
        },
        children: wiki.content
    });
});
const supportedWikiTranslations = LanguageData/* languageData.filter */.i.filter((lang)=>lang.locale !== "en").map((lang)=>lang.locale);
const WikiMainContent = (param)=>{
    let { wiki: wikiData  } = param;
    var ref;
    const [isTranslating, setIsTranslating] = (0,react.useState)(false);
    const [contentLang, setContentLang] = (0,react.useState)("en");
    const [wikiContentState, setWikiContentState] = (0,react.useState)(wikiData.content);
    const cachedWikiTranslation = (0,react.useRef)(null);
    const { colorMode  } = (0,index_esm/* useColorMode */.If)();
    const locale = (0,es.useSelector)((state)=>state.app.language);
    const isLocaleWikiTranslationSupported = supportedWikiTranslations.includes(locale);
    const wikiContent = wikiContentState !== null && wikiContentState !== void 0 ? wikiContentState : wikiData.content;
    let content = wikiContent.replace(/<br( )*\/?>/g, "\n") || "";
    const matchRegex = /\$\$widget\d(.*?\))\$\$/;
    (ref = content.match(new RegExp(matchRegex, "g"))) === null || ref === void 0 ? void 0 : ref.forEach((match)=>{
        var ref;
        const widgetContent = (ref = match.match(matchRegex)) === null || ref === void 0 ? void 0 : ref[1];
        if (widgetContent) {
            content = content.replaceAll(match, widgetContent);
        }
    });
    const modifiedContentWiki = {
        ...wikiData,
        content
    };
    (0,react.useEffect)(()=>{
        /* Set content state after wiki content loads
    to allow update of wiki content to translated content */ setWikiContentState(wikiData.content);
    }, [
        wikiData.content
    ]);
    (0,react.useEffect)(()=>{
        /* When the lang changes from one locale to another,
     change wiki content lang to 'en' to prevent entering
     a state that breaks translation btn logic */ if (isLocaleWikiTranslationSupported) {
            setContentLang("en");
            setWikiContentState(wikiData.content);
        }
    }, [
        locale
    ]);
    const SwitchBtn = (param)=>{
        let { btnLocale  } = param;
        const commonStyles = {
            paddingX: 3,
            fontWeight: "medium",
            fontSize: "14px"
        };
        const activeBtnStyle = {
            bg: "white",
            color: "brand.500",
            boxShadow: "sm",
            _dark: {
                color: "brand.500",
                bg: "gray.700"
            },
            _hover: {
                bgcolor: "gray.700",
                color: "brand.500"
            },
            _active: {
                bgcolor: "gray.700"
            }
        };
        const unactiveBtnStyle = {
            color: "gray.500",
            bgColor: "transparent",
            _dark: {
                color: "white"
            },
            _hover: {
                bgColor: "transparent"
            },
            _active: {
                bgcolor: "transparent"
            }
        };
        const styles = Object.assign(commonStyles, btnLocale === contentLang ? activeBtnStyle : unactiveBtnStyle);
        const handleClick = async ()=>{
            (0,googleAnalytics/* logEvent */.K)({
                action: "TRANSLATE_WIKI",
                category: btnLocale,
                label: wikiData.id,
                value: 1
            });
            if (btnLocale !== contentLang) {
                if (contentLang === "en") {
                    var ref;
                    if (cachedWikiTranslation === null || cachedWikiTranslation === void 0 ? void 0 : (ref = cachedWikiTranslation.current) === null || ref === void 0 ? void 0 : ref[btnLocale]) {
                        setWikiContentState(cachedWikiTranslation.current[btnLocale]);
                        setContentLang(btnLocale);
                        return;
                    }
                    setIsTranslating(true);
                    const response = await fetch("/api/translate-wiki", {
                        method: "POST",
                        headers: {
                            "Content-type": "application/json"
                        },
                        body: JSON.stringify({
                            title: wikiData.title,
                            content: wikiData.content,
                            lang: btnLocale
                        })
                    });
                    if (response.status === 200) {
                        const result = await response.json();
                        const translatedContent = result.content.join("\n\n");
                        setWikiContentState(translatedContent);
                        cachedWikiTranslation.current = {
                            [locale]: translatedContent
                        };
                        setContentLang(btnLocale);
                    }
                    setIsTranslating(false);
                } else {
                    setWikiContentState(wikiData.content);
                    setContentLang(btnLocale);
                }
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
            onClick: handleClick,
            sx: styles,
            children: isTranslating && btnLocale !== contentLang ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                size: "sm",
                sx: {
                    color: "brand.500",
                    _dark: {
                        color: "white"
                    }
                }
            }) : btnLocale.toUpperCase()
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
        py: 8,
        px: {
            base: 4,
            md: 6,
            xl: 12
        },
        pr: {
            md: 15,
            xl: 12
        },
        maxW: {
            base: "100%",
            xl: "900px"
        },
        mx: "auto",
        minH: {
            base: "unset",
            xl: "calc(100vh - 70px)"
        },
        mb: {
            xl: "3rem"
        },
        borderColor: "rankingListBorder",
        position: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Heading */.X6, {
                mb: 8,
                display: {
                    base: "none",
                    md: "none",
                    xl: "block"
                },
                width: "75%",
                children: wikiData.title
            }),
            isLocaleWikiTranslationSupported && /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                sx: {
                    position: {
                        base: "unset",
                        xl: "absolute"
                    },
                    right: {
                        base: "unset",
                        xl: 12
                    },
                    top: {
                        base: "unset",
                        xl: 6
                    },
                    width: "105px",
                    marginX: "auto",
                    marginBottom: "26px",
                    textAlign: "center",
                    borderColor: "gray.200",
                    borderWidth: "1px",
                    borderRadius: "lg",
                    bgColor: "transparent",
                    p: 1.5,
                    _dark: {
                        borderColor: "cardBorderColor"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchBtn, {
                        btnLocale: "en"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchBtn, {
                        btnLocale: locale
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                className: "".concat((markdown_module_default()).markdownBody, " ").concat(colorMode === "dark" && (markdown_module_default()).markdownBodyDark),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownRender, {
                        wiki: modifiedContentWiki
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WikiFlaggingSystem, {
                        id: wikiData.id
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var WikiPage_WikiMainContent = (/*#__PURE__*/react.memo(WikiMainContent));


/***/ }),

/***/ "./src/utils/DataTransform/mediaUtils.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ checkMediaDefaultId; },
/* harmony export */   "w": function() { return /* binding */ constructMediaUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");
/* harmony import */ var _data_Constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/data/Constants.ts");


const VIMEO_DEFAULT_URL = "https://vimeo.com/";
const checkMediaDefaultId = (id)=>{
    return id.includes(_data_Constants__WEBPACK_IMPORTED_MODULE_1__/* .MEDIA_POST_DEFAULT_ID */ .ft);
};
const constructMediaUrl = (media)=>{
    let url;
    switch(media.source){
        case "YOUTUBE":
            url = "https://i3.ytimg.com/vi/".concat(media.id, "/maxresdefault.jpg");
            break;
        case "VIMEO":
            url = VIMEO_DEFAULT_URL + media.id;
            break;
        default:
            url = "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(media.id);
    }
    return url;
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiFields.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CC": function() { return /* binding */ getActivityMetadataById; },
/* harmony export */   "lU": function() { return /* binding */ getWikiMetadataById; }
/* harmony export */ });
/* unused harmony export getCategoryById */
const getWikiMetadataById = (wiki, id)=>wiki.metadata.find((m)=>m.id === id);
const getActivityMetadataById = (activity, id)=>activity.content[0].metadata.find((m)=>m.id === id);
const getCategoryById = (wiki, id)=>wiki.categories.find((c)=>c.id === id);


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiImageUrl.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getWikiImageUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");

const getWikiImageUrl = (imageObj)=>{
    var ref;
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(imageObj ? (ref = imageObj[0]) === null || ref === void 0 ? void 0 : ref.id : "");
};


/***/ }),

/***/ "./src/styles/markdown.module.css":
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionDisplay":"markdown_accordionDisplay__BD_VP","accordionUnDisplay":"markdown_accordionUnDisplay__f_syU","accordionOpen":"markdown_accordionOpen__G9_eQ","accordionClose":"markdown_accordionClose__NjRB7","markdownBody":"markdown_markdownBody__i1xqq","table-container":"markdown_table-container__Y0NNm","anchor":"markdown_anchor__V_ihR","no-list":"markdown_no-list__6FH8U","markdownBodyDark":"markdown_markdownBodyDark__P4Pc5"};

/***/ })

}]);